import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#each this.icons as |icon|}}\n  {{d-icon icon translatedTitle=this.dasherizedTitle}}\n{{/each}}\n\n<span class=\"name\">\n  {{this.label}}\n</span>", {
  moduleName: "select-kit/components/select-kit/select-kit-row.hbs"
});